import { EventEmitter, Input, Output, Directive } from '@angular/core';

@Directive()
export class CellViewBase {
    @Input() data;
    @Input() column;

    @Output() cellClick = new EventEmitter();

    tableCellClick($event) {
        $event.preventDefault();
        this.cellClick.emit(this.data);
    }
}
